import type { RouteRecordRaw } from 'vue-router';

const About = () => import('@/pages/website/AboutPage.vue');
const Login = () => import('@/pages/website/LoginPage.vue');
const Signup = () => import('@/pages/website/SignupPage.vue');
const Pay = () => import('@/pages/website/PayPage.vue');
const PayResult = () => import('@/pages/website/PayResultPage.vue');
const MyPlan = () => import('@/pages/website/MyPlanPage.vue');

const routes: RouteRecordRaw[] = [
  {
    // El sitio público es solo acceso al panel admin: la raíz va directo al login.
    path: '/',
    redirect: '/login',
  },
  {
    // Mi Plan: vista consolidada (plan + facturación + facturas + pago). Protegida por
    // token firmado que mintea la app (no IDOR). La app linkea acá.
    path: '/my-plan',
    name: 'my-plan',
    components: {
      default: MyPlan,
    },
  },
  {
    // Pago de factura (la abre el cliente desde la app bloqueada). Redirige a /my-plan.
    path: '/pay',
    name: 'pay',
    components: {
      default: Pay,
    },
  },
  {
    path: '/pay/result',
    name: 'pay-result',
    components: {
      default: PayResult,
    },
  },
  {
    path: '/about',
    name: 'about',
    components: {
      default: About,
    },
  },
  {
    path: '/login',
    name: 'login',
    components: {
      default: Login,
    },
  },
  {
    path: '/signup',
    name: 'signup',
    components: {
      default: Signup,
    },
  },
];

export default routes;
